import alt from '../alt';
import Immutable from 'seamless-immutable';
import {seamlessImmutable} from 'epic-alt-utils/index';

@seamlessImmutable
class FaqStore {
    constructor() {
        this.on('error', (error) => {console.error(error);});
        this.state = Immutable({
            faqData: null
        });
    }
}

export default alt.createStore(FaqStore, 'FaqStore');
